// El backend aplica el alcance de empresa/sucursal también en lecturas por ID.
export const canAccessPlan = (user) => !!user?.accessToken && String(user?.privilege || '').toLowerCase() === 'master';
export const canViewPlan = user => !!user?.accessToken;
